import messages from "./messages";
import checkMissingTranslations from "./missing";

const i18n_config = {
    messages,
    locale: 'fr',
    fallbackLocale: 'fr',
    silentFallbackWarn: true
}

export { checkMissingTranslations };

export default i18n_config;

